
<div class="toggle_view">
  <mat-button-toggle-group
name="fontStyle"
aria-label="Font Style"
color="accent"
class="m-3"

>
<mat-button-toggle value="list" color="accent" (click)="onList()"
  ><mat-icon class="example-tab-icon"
    >list</mat-icon
  ></mat-button-toggle
>
<mat-button-toggle value="grid" (click)="onGrid()"
  ><mat-icon class="example-tab-icon"
    >view_module</mat-icon
  ></mat-button-toggle
>
</mat-button-toggle-group>
</div>


<ng-container *ngIf="gridView">
  <form [formGroup]="lessorStakeholderArrayForm" >
    <div class="display">
      <div class="main_entry rep_alteration" style="grid-template-columns: repeat(2, 1fr); grid-column-gap:0 ;">
        <div class="rep_entry"
        *ngFor="let lessor of lessorStakeholderArrayForm.get('LessorStakeholder')['controls']; index as i"
          (click)="onEdit(lessor.value, i)"
        >
          <p class="number">{{i + 1}}</p>
          <p class="info">Name: {{lessor?.value.Name}}</p>
          <p class="info">Phone: {{lessor?.value.PhoneNo}}</p>
          <p class="info">Address: {{lessor?.value.Address}}</p>
          <p class="info">Account Number: {{lessor?.value.AccountNo}}</p>
          <p class="info">Bank Name: {{getBankName(lessor?.value.BankId)}}</p>
          <p (click)=$event.stopImmediatePropagation()>
            <i class="ti-trash" (click)="onDelete(lessor.value, i)"></i>
          </p>

        </div>
        </div>
        </div>
    </form>
</ng-container>


  <div class="card mt-3 " *ngIf="listView">
    <div class="table-responsive">
    <table class="table table-hover" >
      <thead>
        <tr>
          <th scope="col">S/N</th>
          <th scope="col">Name</th>
          <th scope="col">Phone</th>
          <th scope="col">Address</th>
          <th scope="col">Account Number</th>
          <th scope="col">Bank Name</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody >
        <tr  *ngFor="let lessor of lessorStakeholderArrayForm.get('LessorStakeholder')['controls']; index as i"

        >
          <th scope="row">{{i + 1}}</th>
          <td>{{lessor?.value.Name}}</td>
          <td>{{lessor?.value.PhoneNo}}</td>
          <td> {{lessor?.value.Address}}</td>
          <td>{{lessor?.value.AccountNo}}</td>
          <td>{{getBankName(lessor?.value.BankId)}}</td>
          <td (click)="$event.stopImmediatePropagation()" style="cursor: pointer; font-size: 1.5rem;">
            <i class="ti-pencil" (click)="onEdit(lessor.value, i)"></i>
            <i class="ti-trash" style="margin-left: 2rem;" (click)="onDelete(lessor.value, i)"></i>
           </td>
        </tr>

      </tbody>
    </table>
  </div>
  </div>
